import _ from 'lodash';

export const isRefreshRequired = state => {
  return Date.now() > _.get(state, ['refresh', 'showRefreshAfter']);
};
